import { Component } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ErrorComponent, SelectComponent } from '@group24ag/flowkit';

@Component({
  imports: [ErrorComponent, FormsModule, ReactiveFormsModule, SelectComponent],
  selector: 'app-ui-select',
  template: `
    <div>
      <h1 class="heading-title">Selects</h1>
      <div class="flex flex-col gap-10">
        <ng-template #selectedTemplateRef let-item="item">
          {{ item }}
        </ng-template>
        <ng-template #optionTemplateRef let-option="option">
          {{ option }}
        </ng-template>
        <flk-select
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [formControl]="control1"
          [options]="stringOptions"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96" />
        <flk-select
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [formControl]="control2"
          [options]="stringOptions"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96" />
        <flk-select
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [formControl]="control3"
          [options]="stringOptions"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96">
          <flk-error>Field is required</flk-error>
        </flk-select>
        <flk-select
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [formControl]="control1"
          [options]="lotsOfStringOptions"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96">
        </flk-select>

        <ng-template #selectedTemplateRef4 let-item="item">
          {{ item.name }}
        </ng-template>
        <ng-template #optionTemplateRef4 let-option="option">
          {{ option.name }}
        </ng-template>
        <flk-select
          [compareWith]="compareWith"
          [selectedTemplate]="selectedTemplateRef4"
          [optionTemplate]="optionTemplateRef4"
          [formControl]="control4"
          [options]="objectOptions"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96" />
      </div>
    </div>
  `,
})
export class UISelectComponent {
  placeholder = 'Select your name';
  label = 'Name';

  stringOptions = ['Foo', 'Bar'];
  objectOptions = [
    { id: 1, name: 'Foo' },
    { id: 2, name: 'Bar' },
  ];
  lotsOfStringOptions = [
    'Foo',
    'Bar',
    'Baz',
    'Qux',
    'Quux',
    'Corge',
    'Grault',
    'Garply',
    'Waldo',
    'Fred',
    'Plugh',
    'Xyzzy',
    'Thud',
  ];

  control1 = new FormControl('Foo');
  control2 = new FormControl({ value: 'Foo', disabled: true });
  control3 = new FormControl('', [Validators.required]);

  compareWith = (it1: any, it2: any) => it1.id === it2.id;
  control4 = new FormControl({
    value: { id: 1, name: 'Foo' },
    disabled: false,
  });
}
